import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { EmotionalHook } from '../components/EmotionalHook';
import { FailedMethods } from '../components/FailedMethods';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { ProtocolIncludes } from '../components/ProtocolIncludes';
import { PowerTools } from '../components/PowerTools';
import { FinalResult } from '../components/FinalResult';
import { CTASection } from '../components/CTASection';
import { SectionDivider } from '../components/SectionDivider';
export function LandingPage() {
  return <main className="min-h-screen bg-zinc-950 text-zinc-200 selection:bg-amber-500/30 selection:text-amber-200 font-sans" data-id="element-140">
      <HeroSection data-id="element-141" />
      <SectionDivider data-id="element-142" />
      <EmotionalHook data-id="element-143" />
      <SectionDivider data-id="element-144" />
      <FailedMethods data-id="element-145" />
      <SectionDivider data-id="element-146" />
      <UniqueMechanism data-id="element-147" />
      <SectionDivider data-id="element-148" />
      <ProtocolIncludes data-id="element-149" />
      <SectionDivider data-id="element-150" />
      <PowerTools data-id="element-151" />
      <SectionDivider data-id="element-152" />
      <FinalResult data-id="element-153" />
      <CTASection data-id="element-154" />

      <footer className="py-8 text-center text-zinc-600 text-sm border-t border-zinc-900 mt-12" data-id="element-155">
        <p data-id="element-156">
          © {new Date().getFullYear()} Protocolo de Cierre de Ciclos. Todos los
          derechos reservados.
        </p>
      </footer>
    </main>;
}